export type CategoryMeta = {
  slug: string;
  name: string;
  description: string;
  cover: string;
  count?: number;
  /** Ürün eşleştirme anahtar kelimeleri (ad + kategori + slug içinde aranır, küçük harf). */
  keywords: string[];
  /** GEO: kategori SSS bloğu (FAQPage şeması ile yayınlanır). */
  faqs?: { q: string; a: string }[];
  /** Kapak yüklenemezse gösterilecek yedek görsel. */
  fallback?: string;
  /**
   * Kategori SEO & CRO metni — ürün ızgarasının altında yayınlanır.
   * Kurallar: teknik spesifikasyon iddiası YOK (watt/saniye/nm/garanti süresi
   * yazılmaz), linkler yalnızca gerçek route'lara verilir
   * (catalog-consistency test bekçisi).
   */
  seo: {
    /** Bölüm başlığı (h2). */
    title: string;
    /** Her zaman görünür kısa giriş (1-2 cümle). */
    intro: string;
    /** "Devamını oku" ile açılan paragraflar. */
    more: string[];
    /** Madde listesi (ürün grubu / seçim kriteri). */
    bullets?: string[];
    /** İç linkler — label + gerçek site-içi href. */
    links: { label: string; href: string }[];
  };
};

export const categoriesMeta: CategoryMeta[] = [
  {
    slug: "protez-tirnak",
    name: "Protez Tırnak",
    description: "Qnail Professional jel, akrilik ve polygel ile salon kalitesinde protez tırnak — setler, formlar ve aksesuarlar Ono MAC'te.",
    cover: "/images/categories/protez/cover.jpg",
    count: 10,
    keywords: ["protez"],
    faqs: [
      { q: "Protez tırnak doğal tırnağa zarar verir mi?", a: "Doğru uygulanıp doğru çıkarıldığında hayır. Tırnak yüzeyini inceltmeden, uygun ürünle evde de güvenle uygulanır." },
      { q: "Jel tip mi akrilik mi seçmeliyim?", a: "Yeni başlayanlar için jel tip daha pratiktir; akrilik daha dayanıklı ama deneyim ister. Polygel ikisinin ortasıdır." },
      { q: "Protez tırnak kaç gün kullanılır?", a: "Uygulamaya bağlı 2-4 hafta. Uçlarda kalkma olursa erken yenileyin." },
      { q: "Protez tırnağı evde çıkarabilir miyim?", a: "Evet — asetonla bekletme + nazik itme yöntemiyle. Kazımayın, doğal tırnağı inceltirsiniz." },
    ],
    seo: {
      title: "Protez Tırnak Malzemeleri Satın Al",
      intro:
        "Salon kalitesinde protez tırnak evde de mümkün — doğru jel, doğru tip ve doğru hazırlıkla. Qnail Professional protez serisi; builder jeller, soft gel tipler, şablonlar ve yapıştırıcılarla komple set kurmanı sağlar.",
      more: [
        "Protez tırnak alışverişinde ilk karar yöntemdir: hazır soft gel tips hızlı ve pratik sonuç verir, builder jel ile güçlendirme doğal tırnağı da destekler, hamur jel ve poly gel ise uzatma ve şekillendirmede kontrol sunar. Yeni başlıyorsan tips + yapıştırıcı ikilisiyle başla, elin alıştıkça forma geç.",
        "Dayanıklılığın sırrı hazırlıktadır: matlaştırma, yağdan arındırma ve primer adımı atlanmadan yapılan protezler haftalarca kalkmadan kalır. Çıkarırken asla çekip koparma — uygun sökücüyle bekletip nazikçe itmek doğal tırnağını korur.",
        "Ono MAC'ten protez alışverişinde %100 orijinal ürün, hızlı kargo ve 14 gün ücretsiz iade güvencesi alırsın. Hangi yöntemin sana uygun olduğunu bilmiyorsan önce rehberlere göz at, sonra ihtiyacın olan ürünleri sepete ekle.",
      ],
      bullets: [
        "Hızlı sonuç: soft gel tips + fırçalı yapıştırıcı",
        "Güçlendirme: builder jel ile apex desteği",
        "Şekillendirme: hamur jel ve poly gel ile uzatma",
        "Çıkarma: sökücü + portakal çubuğu ile nazik söküm",
      ],
      links: [
        { label: "Protez Nasıl Uygulanır? Adım Adım Rehber", href: "/blog/protez-tirnak-nasil-uygulanir-adim-adim-rehber" },
        { label: "Builder Gel No:13", href: "/urunler/qnail-builder-gel-50ml" },
        { label: "Soft Gel Tips Almond", href: "/urunler/soft-gel-tips-medium-almond-550-li-sftgl-malm" },
        { label: "Çok Satan Protez Ürünleri", href: "/koleksiyon/cok-satanlar" },
      ],
    },
  },
  {
    slug: "jel-oje",
    name: "Jel Oje",
    description: "Qnail Professional jel görünümlü oje koleksiyonu — 14 gün kalıcılık, evde kolay uygulama Ono MAC'te.",
    cover: "/images/categories/jel-takma.jpg",
    keywords: ["jel", "oje", "ruby", "blush", "stardust", "top coat", "chrome"],
    faqs: [
      { q: "Kalıcı oje evde lamba olmadan kurur mu?", a: "Jel formüller UV/LED lambada kürlenir; lambasız tam dayanıklılık alınmaz. Başlangıç setleri mini lamba içerir." },
      { q: "Jel oje kaç gün dayanır?", a: "Doğru hazırlıkla 7-14 gün. Tırnak yağı ve eldivenle ev işi ömrü uzatır." },
      { q: "Jel oje tırnağı sarartır mı?", a: "Base kat kullanıldığında hayır. Koyu renklerde base kat şarttır." },
      { q: "Başlangıç için hangi renk önerilir?", a: "Nude ve blush tonları hata affeder; ilk denemede koyu renk yerine açık ton seçin." },
    ],
    seo: {
      title: "Jel Oje Çeşitleri ve Renkleri",
      intro:
        "Günlerce soyulmadan kalan parlak renkler için jel oje en pratik çözüm. Qnail Professional renkleri; yoğun pigmenti ve kolay sürümüyle evde salon sonucu verir.",
      more: [
        "Jel oje seçerken tenine uyan tona odaklan: nude ve blush tonları günlük kullanımda hata affeder, ruby ve bordo tonları özel günlerde öne çıkar, chrome ve stardust efektler nail art sevenlere hitap eder. İlk kez deniyorsan açık tonda başla.",
        "Kalıcılığın üç adımı vardır: temiz hazırlık, ince katlar ve top coat ile mühürleme. Base kat tırnağı sararmadan korur, top coat parlaklığı günlerce kilitler. Her katı lambada ürün talimatındaki süre kadar kürletmeyi unutma.",
        "Ono MAC jel oje alışverişinde %100 orijinal ürün ve hızlı kargo standarttır. Renk kararsızlığı yaşıyorsan popüler renk rehberine bak, set kurmak istiyorsan başlangıç setleri daha avantajlıdır.",
      ],
      bullets: [
        "Günlük: nude ve blush tonları",
        "Özel gün: ruby, bordo ve stardust",
        "Koruma: base kat + top coat ikilisi",
        "Kürleme: UV/LED lamba ile her kat",
      ],
      links: [
        { label: "En Popüler Kalıcı Oje Renkleri", href: "/blog/kalici-oje-renkleri-en-populer-10-renk" },
        { label: "UNO Kalıcı Oje", href: "/urunler/uno-kalici-oje-156-renk-10-ml-plhsgel" },
        { label: "Kalıcı Oje Nasıl Uygulanır?", href: "/blog/kalici-oje-nedir-evde-uygulama-rehberi" },
      ],
    },
  },
  {
    slug: "tirnak-bakimi",
    name: "Tırnak Bakımı",
    description: "Qnail Professional güçlendirici, serum ve bakım kitleri — kırılgan tırnaklara evde salon bakımı.",
    cover: "/images/categories/bakim.jpg",
    keywords: ["bakım", "bakim", "serum", "güçlendirici", "guclendirici", "keratin", "yağ", "yag", "törpü", "torpu", "kit"],
    faqs: [
      { q: "Kırılan tırnaklar için ilk adım ne olmalı?", a: "Keratin serum + günlük kütikül yağı. 2 hafta düzenli kullanımda kırılma belirgin azalır." },
      { q: "Tırnak serumu ojeyle birlikte kullanılır mı?", a: "Evet — oje altına baz, üstüne bakım olarak. Tırnak yağı kütiküle masajla yedirilir." },
      { q: "Bakım kiti evde yeterli mi?", a: "Törpü + itici + yağ üçlüsü haftalık rutin için yeterlidir." },
    ],
    seo: {
      title: "Tırnak Bakım Ürünleri",
      intro:
        "Kırılan, soyulan ve güçsüz tırnakların çözümü düzenli bakımdır. Qnail Professional bakım serisi; serum, yağ ve törpü üçlüsüyle evde salon rutini kurmanı sağlar.",
      more: [
        "Bakım rutinini üç adıma böl: haftada bir nazikçe şekillendir ve yüzeyi düzelt, her gün kütikül yağıyla nemlendir, ojeli dönemde base kat ile tırnağı koru. Düzenli uygulamada iki haftada kırılmaların azaldığını fark edersin.",
        "Doğru törpü seçimi de bakımın parçasıdır: doğal tırnakta ince numara kullan, tek yöne törpüle, testere hareketinden kaçın. Metal törpüler temizlenebilir yapısıyla uzun ömürlüdür.",
        "Ono MAC'ten bakım alışverişinde %100 orijinal ürün ve 14 gün ücretsiz iade güvencesi vardır. Rutinini kurarken manikür rehberinden adım adım ilerle.",
      ],
      bullets: [
        "Günlük: kütikül yağı ile nemlendirme",
        "Haftalık: törpü + şekillendirme",
        "Ojeli dönem: base kat ile koruma",
        "Temizlik: cleanser + tüysüz mendil",
      ],
      links: [
        { label: "Manikür Nasıl Yapılır?", href: "/blog/manikur-nasil-yapilir" },
        { label: "Cleanser 250 ml", href: "/urunler/cleanser-250-ml-cleanser" },
        { label: "Tüysüz Mendil 540'lı", href: "/urunler/tuysuz-mendil-540-li-pol-rmvr" },
      ],
    },
  },
  {
    slug: "tirnak-guclendirici",
    name: "Tırnak Güçlendirici",
    description: "Qnail Professional ince ve kırılgan tırnaklar için güçlendirici ojeler — ışıltılı ve sütlü seriler Ono MAC'te.",
    cover: "/images/categories/guclendirici.jpg",
    keywords: ["güçlendirici", "guclendirici", "keratin"],
    faqs: [
      { q: "Güçlendirici oje nasıl uygulanır?", a: "Temiz tırnağa 2 ince kat, 3 günde bir üstten 1 kat tazeleme. 2 haftada soyup yenileyin." },
      { q: "Işıltılı seri ile sütlü seri farkı ne?", a: "Işıltılı seri renk + ışıltı verir; sütlü seri doğal, opak nude bitiş sağlar." },
      { q: "Güçlendirici üstüne renk sürülür mü?", a: "Evet — kuruduktan sonra baz kat gibi davranır, üstüne istediğiniz ojeyi sürebilirsiniz." },
    ],
    seo: {
      title: "Tırnak Güçlendirici Oje",
      intro:
        "İnce ve çabuk kırılan tırnaklar için güçlendirici oje hem korur hem renklendirir. Qnail Professional güçlendiriciler; keratin destekli yapısıyla günlük kullanıma uygundur.",
      more: [
        "Güçlendirici seçerken bitişe karar ver: sütlü seriler doğal nude görünümle ofis ve günlük hayata uyar, ışıltılı seriler renk ve parlaklık katar. İkisi de üstüne renk sürülebilir — baz kat gibi davranır.",
        "Uygulama basittir: temiz tırnağa iki ince kat sür, birkaç günde bir üstten tek kat tazele, iki haftada bir soyup yenile. Düzenli kullanımda tırnakların kırılmadan uzadığını görürsün.",
        "Ono MAC'te %100 orijinal ürün ve hızlı kargo ile sipariş verebilirsin. Renk seçiminde kararsızsan tenine uyan oje renkleri rehberine göz at.",
      ],
      bullets: [
        "Doğal bitiş: sütlü nude seri",
        "Parlak bitiş: ışıltılı seri",
        "Rutin: 2 kat + düzenli tazeleme",
        "Üstüne renk sürülebilir",
      ],
      links: [
        { label: "Buğday Tene Uyan Oje Renkleri", href: "/blog/bugday-tene-yakisan-oje-renkleri" },
        { label: "UNO Kalıcı Oje", href: "/urunler/uno-kalici-oje-156-renk-10-ml-plhsgel" },
        { label: "Tırnak Bakım Ürünleri", href: "/kategori/tirnak-bakimi" },
      ],
    },
  },
  {
    slug: "manikur",
    name: "Manikür",
    description: "Qnail Professional evde manikür için french setleri, törpü, kütikül bakımı ve şekillendirme ürünleri.",
    cover: "/images/categories/manikur.jpg",
    keywords: ["french", "manikür", "manikur", "törpü", "torpu", "kütikül", "kutikul", "bakım kiti", "şekillendirme"],
    faqs: [
      { q: "Evde french nasıl yapılır?", a: "Şablon + beyaz uç + nude baz üçlüsüyle 10 dakikada. French manikür seti tüm adımları içerir." },
      { q: "Kütikül nasıl itilir?", a: "Ilık suda 2 dk bekletip tahta/ metal iticiyle nazikçe. Kesmek yerine itmek daha sağlıklıdır." },
      { q: "Manikür ne sıklıkla yapılmalı?", a: "Haftada 1 şekillendirme + günlük yağ bakımı ideal rutindir." },
    ],
    seo: {
      title: "Evde Manikür Seti ve Ürünleri",
      intro:
        "Salon randevusu beklemeden evde bakımlı eller: doğru törpü, kütikül itici ve french setiyle haftalık manikür rutini 20 dakikada biter.",
      more: [
        "Manikür setini ihtiyacına göre kur: temel törpü ve buffer şekillendirmeyi, portakal çubuğu kütikül itmeyi, french stamper simetrik beyaz ucu kolaylaştırır. Klasik görünüm sevenler nude baz + beyaz uç ikilisini, modern sevenler renkli french denemelerini tercih eder.",
        "Teknik basittir: tırnağı tek yöne törpüle, kütikülü ılık su sonrası nazikçe it, yüzeyi buffer ile düzelt. Kesmek yerine itmek tırnak etini korur ve manikürün ömrünü uzatır.",
        "Ono MAC manikür ürünlerinde %100 orijinal garantisi ve hızlı kargo sunar. Adım adım görsel anlatım için manikür rehberini, hazır french için stamper rehberini incele.",
      ],
      bullets: [
        "Şekil: törpü + buffer ikilisi",
        "Kütikül: portakal çubuğu ile itme",
        "French: stamper ile simetrik uç",
        "Rutin: haftada 1 manikür + günlük yağ",
      ],
      links: [
        { label: "Manikür Nasıl Yapılır?", href: "/blog/manikur-nasil-yapilir" },
        { label: "French Stamper Nasıl Kullanılır?", href: "/blog/french-stamper-nasil-kullanilir" },
        { label: "French Stamper", href: "/urunler/qnail-french-stamper" },
        { label: "Portakal Çubuğu 100'lü", href: "/urunler/portakal-cubugu-100-lu-pstck" },
      ],
    },
  },
  {
    slug: "pedikur",
    name: "Pedikür",
    description: "Qnail Professional el ve ayak bakımı — besleyici yağlar, serumlar ve bakım kitleri Ono MAC'te.",
    cover: "/images/categories/pedikur.jpg",
    keywords: ["pedikür", "pedikur", "ayak", "besleyici", "yağ", "yag", "serum", "bakım", "prep", "hazırlık", "hazirlik", "çıkarıcı", "cikarici", "remover", "dehydrator"],
    faqs: [
      { q: "Evde pedikür için neler gerekli?", a: "Ilık su bakımı, törpü, nemlendirici yağ ve oje. Bakım kitleri temel seti karşılar." },
      { q: "Ayak tırnağı ojesi farklı mı olmalı?", a: "Formül aynı; ayak tırnağında düz kesim batmayı önler." },
      { q: "Yazın pedikür sıklığı ne olmalı?", a: "2 haftada 1 bakım + günlük nemlendirme önerilir." },
    ],
    seo: {
      title: "Evde Pedikür ve Ayak Bakımı",
      intro:
        "Yaz-kış bakımlı ayaklar için pedikür rutini evde de kurulur. Ilık su bakımı, doğru törpü ve nemlendirici yağ üçlüsüyle ayak bakımın 30 dakikada tamamlanır.",
      more: [
        "Pedikürde sıra önemlidir: önce ılık suda yumuşat, tırnakları düz kesip kenarları hafif yuvarla, yüzeyi törpüle, bolca nemlendir. Ayak tırnağında düz kesim batmayı önler; köşeleri derine oymaktan kaçın.",
        "Renk adımında kalıcı oje ayak tırnağında da aynı şekilde uygulanır — base kat, iki ince renk, top coat. Yazın sandalet sezonu öncesi iki haftada bir bakım ritmi idealdir.",
        "Ono MAC bakım ürünleriyle pedikür setini tek sepette tamamlayabilirsin. El bakımı için manikür kategorisine, oje renkleri için jel oje rehberine göz at.",
      ],
      bullets: [
        "Yumuşatma: ılık su bakımı",
        "Kesim: düz kesim, batmayı önler",
        "Nem: besleyici yağ ile masaj",
        "Renk: base + renk + top coat",
      ],
      links: [
        { label: "Evde Pedikür Adım Adım", href: "/blog/evde-pedikur-adim-adim-kuvetten-ojeye" },
        { label: "Manikür Ürünleri", href: "/kategori/manikur" },
        { label: "Tırnak Bakım Ürünleri", href: "/kategori/tirnak-bakimi" },
      ],
    },
  },
  {
    slug: "setler",
    name: "Setler",
    description: "Qnail Professional avantajlı setler — french manikür, nude oje, bakım ve frez uç setleri Ono MAC'te.",
    cover: "/images/categories/setler.jpg",
    keywords: ["set", "kit", "kiti"],
    faqs: [
      { q: "Set almak tek tek almaktan avantajlı mı?", a: "Evet — setler %15-25 avantajlıdır ve uyumlu ürünleri bir arada sunar." },
      { q: "Başlangıç için hangi set?", a: "French manikür seti veya bakım kiti 3'lü ile başlayın; ihtiyaca göre büyütün." },
      { q: "Frez uç seti evde kullanılır mı?", a: "Düşük devirli cihazla evet; yüksek devir ve baskıdan kaçının." },
    ],
    seo: {
      title: "Avantajlı Tırnak Setleri",
      intro:
        "Tek tek almaktan daha avantajlı: uyumlu ürünler bir arada, toplam fiyat daha uygun. Başlangıç setleri ilk kurulumu, bakım kitleri rutini, frez setleri ekipmanı tamamlar.",
      more: [
        "Set seçerken hedefini belirle: ilk kez tırnak yapacaksan french veya başlangıç seti tüm adımları kapsar; rutinin oturmuşsa bakım kiti eksiklerini kapatır; proteze geçtiysen frez uç seti şekillendirme ve çıkarmayı hızlandırır.",
        "Setlerin gizli avantajı uyumluluktur: baz, renk ve top coat aynı sistemden geldiğinde tutunma ve kürleme sorunsuz olur. Parça parça farklı sistem toplamak yerine setle başlamak hata payını azaltır.",
        "Ono MAC setlerinde %100 orijinal ürün ve hızlı kargo standarttır. İndirimleri kaçırmamak için indirimliler koleksiyonunu takip et.",
      ],
      bullets: [
        "İlk kurulum: french ve başlangıç setleri",
        "Rutin: bakım kitleri",
        "Ekipman: frez uç setleri",
        "Fırsat: indirimliler koleksiyonu",
      ],
      links: [
        { label: "İndirimli Ürünler", href: "/koleksiyon/indirimliler" },
        { label: "Manikür Başlangıç Seti Önerileri", href: "/blog/nail-art-malzemeleri-baslangic-seti-onerileri" },
        { label: "Frez Uç Seti 5'li", href: "/urunler/protez-frez-uc-seti" },
      ],
    },
  },
  {
    slug: "kalici-ojeler",
    name: "Kalıcı Ojeler",
    description: "Qnail Professional haftalarca kalıcı renk — jel oje, ruby, blush ve nude tonlarda kalıcı oje koleksiyonu.",
    cover: "/images/products/uno-color-gel.png",
    fallback: "/images/categories/jel-takma.jpg",
    keywords: ["oje", "jel", "ruby", "blush", "kalıcı", "kalici", "chrome", "stardust", "nude"],
    faqs: [
      { q: "Kalıcı oje ile normal oje farkı ne?", a: "Kalıcı oje UV/LED ile kürlenir, 2-3 hafta soyulmadan kalır; normal oje 2-3 günde aşınır." },
      { q: "Kalıcı oje evde uygulanır mı?", a: "Evet — mini LED lamba + base + renk + top coat ile evde salon sonucu alınır." },
      { q: "Kalıcı oje nasıl çıkarılır?", a: "Asetonla 10 dk bekletip nazikçe itin; kazımayın." },
    ],
    seo: {
      title: "Kalıcı Oje Satın Al — Renkler ve Fiyatlar",
      intro:
        "Haftalarca soyulmayan renk, evde salon sonucu: kalıcı oje kategorisinde nude'dan ruby'e, blush'tan chrome efektlere tüm tonlar seni bekliyor.",
      more: [
        "Kalıcı oje alışverişinde renk kadar sistem de önemlidir: base kat tutunmayı, renk katları opaklığı, top coat parlaklığı ve korumayı üstlenir. Üçünü aynı sistemden seçmek uyum sorunlarını ortadan kaldırır.",
        "Dayanıklılık için ince kat kuralını unutma: iki ince renk katı, tek kalın kattan her zaman uzun ömürlüdür. Uçları kapatmak ve kenarda boşluk bırakmak kalkmayı önler. Çıkarırken sökücüyle bekletip nazikçe it.",
        "Ono MAC'te kalıcı ojeler %100 orijinal ve hızlı kargoyla gelir. Hangi rengin sana yakıştığını merak ediyorsan ten rengine göre oje rehberlerine, uygulamayı öğrenmek için evde uygulama rehberine bak.",
      ],
      bullets: [
        "Sistem: base + renk + top coat",
        "Kural: iki ince kat, ucu kapat",
        "Tonlar: nude, blush, ruby, chrome",
        "Çıkarma: sökücü + nazik itme",
      ],
      links: [
        { label: "Kalıcı Oje Renkleri: En Popüler 10", href: "/blog/kalici-oje-renkleri-en-populer-10-renk" },
        { label: "Kalıcı Oje Nasıl Daha Uzun Kalır?", href: "/blog/kalici-oje-nasil-daha-uzun-kalir" },
        { label: "UNO Rubber Base 15 ml", href: "/urunler/uno-rubber-base-coat-15-ml-15ml-ruba" },
        { label: "UNO Magic Remover", href: "/urunler/qnail-uno-magic-remover" },
      ],
    },
  },
  {
    slug: "nail-art-suslemeler",
    name: "Nail Art ve Süslemeler",
    description: "Qnail Professional sim, chrome, french ve ışıltılı detaylar — tırnak sanatı için her şey Ono MAC'te.",
    cover: "/images/products/inci-tozu-gri.png",
    fallback: "/images/categories/manikur.jpg",
    keywords: ["nail", "art", "simli", "chrome", "french", "yaldız", "yaldiz", "far", "palet", "stardust", "süs", "sus"],
    faqs: [
      { q: "Nail art için hangi ürünler gerekli?", a: "Renkli baz + sim/chrome detay + top coat. French seti desen başlangıcı için idealdir." },
      { q: "Chrome efekti evde yapılır mı?", a: "Evet — chrome toz/efekt ojeyi yapışkan tabakaya uygulayıp top coat ile sabitleyin." },
      { q: "Simli oje çıkarması zor mu?", a: "Folyo + aseton yöntemiyle 10 dakikada çıkar; direkt kazımayın." },
    ],
    seo: {
      title: "Nail Art Malzemeleri: Chrome, İnci Tozu, Taş",
      intro:
        "Sade ojeden sıkılanlara: chrome ayna efekti, inci tozu ışıltısı, mıknatıslı cat eye desenleri ve taş süslemelerle tırnakların minik birer sanat eserine dönüşür.",
      more: [
        "Nail art'e yeni başlıyorsan tek teknikle ilerle: önce ombre süngerle degrade, sonra cat eye mıknatısla manyetik desen, ardından inci veya krom tozuyla efekt. Her teknikte top coat ile mühürlemek deseni günlerce korur.",
        "Taş ve 3D süslerde sabitleme kritiktir: yapışkan tabakaya yerleştir, dibine ince jel köprüsü kur, kenarları top coat ile kapat. Büyük süsleri 1-2 vurgu tırnağında kullanmak hem şık hem dayanıklıdır.",
        "Ono MAC nail art ürünleri %100 orijinaldir ve hızlı kargoyla gelir. Teknik videolu anlatımlar için nail art başlangıç rehberini, hazır desenler için stamper rehberini incele.",
      ],
      bullets: [
        "Degrade: ombre süngeri ile geçiş",
        "Desen: cat eye mıknatıs setleri",
        "Efekt: inci ve krom tozları",
        "Süs: taş ve 3D aksesuarlar",
      ],
      links: [
        { label: "Nail Art Nasıl Yapılır?", href: "/blog/nail-art-nasil-yapilir-baslangic-rehberi" },
        { label: "Ombre Tırnak Nasıl Yapılır?", href: "/blog/ombre-tirnak-nasil-yapilir" },
        { label: "Cat Eye Magnet 6'lı", href: "/urunler/qnail-cat-eye-magnet-6li" },
        { label: "İnci Tozu Pigment", href: "/urunler/qnail-inci-tozu-pigment" },
      ],
    },
  },
  {
    slug: "firca-aksesuar",
    name: "Fırça & Aksesuar",
    description: "Qnail Professional frez uçları, form şablonları, yapıştırıcı ve bakım aksesuarları — profesyonel yardımcılar.",
    cover: "/images/products/uno-stamp.png",
    fallback: "/images/categories/setler.jpg",
    keywords: ["frez", "form", "yapıştırıcı", "yapistirici", "aksesuar", "fırça", "firca", "törpü", "torpu", "itici", "lamba", "cihaz", "brush"],
    faqs: [
      { q: "Frez uçları ne işe yarar?", a: "Protez inceltme, şekillendirme ve çıkarma için. Seramik uçlar yeni başlayanlar için daha güvenlidir." },
      { q: "Form şablonu mu jel tip mi?", a: "Form doğal uzunluk verir, jel tip hızlıdır. İkisi de builder ürünlerle kullanılır." },
      { q: "Aksesuarlar makinede yıkanır mı?", a: "Metal aksesuarlar dezenfektanla silinir; kağıt formlar tek kullanımlıktır." },
    ],
    seo: {
      title: "Tırnak Fırça ve Aksesuarları",
      intro:
        "Sonucun yarısı üründe, yarısı alettedir: doğru fırça, doğru törpü ve doğru uç olmadan en iyi jel bile düzgün durmaz. Profesyonel yardımcılar tek kategoride.",
      more: [
        "Aksesuar alışverişinde işine göre seç: jel yaymak için jel fırçası, çizgi ve detay için nail art fırçası, şekillendirme için törpü ve buffer, protez inceltme için frez uçları. Kurutma için UV/LED lamba, söküm için portakal çubuğu ve mendil tamamlayıcıdır.",
        "Fırça bakımı ömrü belirler: iş bitince cleanser ile sil, jelli bırakma, ışıktan uzak ve kapalı sakla. Kılları dağılan fırça iz bırakır — değişim zamanını erteleme.",
        "Ono MAC aksesuarlarında %100 orijinal ürün ve hızlı kargo standarttır. Hangi fırçanın ne işe yaradığını öğrenmek için fırça rehberini, törpü numaraları için buffer rehberini incele.",
      ],
      bullets: [
        "Yayma: jel fırça setleri",
        "Detay: nail art ve çizim fırçaları",
        "Şekil: törpü, buffer ve frez uçları",
        "Kurutma: UV/LED lambalar",
      ],
      links: [
        { label: "Jel Fırçası Nasıl Kullanılır?", href: "/blog/jel-fircasi-nasil-kullanilir-temizlenir" },
        { label: "3'lü Jel Fırça Seti", href: "/urunler/3-lu-jel-firca-set-brshsg-3" },
        { label: "SUN Max Kurutucu 220W", href: "/urunler/sun-max-uv-led-tirnak-kurutucu-220w-uv-xmax" },
        { label: "Frez Ucu Seçimi", href: "/blog/frez-ucu-secimi-seramik-vs-karbur-hangi-uc-ne-ise-yarar" },
      ],
    },
  },
  {
    slug: "kirpik",
    name: "Kirpik",
    description: "Qnail Professional ile uyumlu ipek kirpik, lifting setleri ve kirpik aksesuarları — etkileyici bakışlar için Onomac'ta.",
    cover: "/images/categories/bakim.jpg",
    keywords: ["kirpik", "lifting", "nagaraku", "cımbız", "cimbiz", "ipek", "göz", "goz", "lash"],
    faqs: [
      { q: "İpek kirpikte C ve D kıvrım farkı ne?", a: "C kıvrım doğal, D kıvrım daha kalkık ve belirgin bakar. Günlük kullanımda C, özel günlerde D tercih edilir." },
      { q: "Kirpik lifting seti evde kullanılır mı?", a: "Evet — talimat sırasına uyup bekleme sürelerine dikkat edildiğinde evde uygulanır." },
      { q: "Nagaraku kirpik numaraları ne anlama gelir?", a: "0.07 kalınlık, C/D kıvrım tipi, 8-15 mm uzunluk aralığıdır. Mix kutular tüm boyları içerir." },
    ],
    seo: {
      title: "İpek Kirpik ve Lifting Setleri",
      intro:
        "Maskaraya veda: ipek kirpik uzatma ve lifting setleriyle haftalarca belirgin bakışlar. Doğru kıvrım, doğru yapıştırıcı ve doğru cımbızla evde de uygulanır.",
      more: [
        "Kirpik seçiminde göz yapın belirleyicidir: C kıvrım doğal günlük görünüm, D kıvrım kalkık ve dikkat çekici bakış verir. Kalınlık ve uzunluk arttıkça doğallık azalır — ilk denemede orta değerlerle başla.",
        "Uygulama üçlüsü kirpik, yapıştırıcı ve cımbızdır: göz altı pedi alt kirpikleri korur, cımbız tekli tutuşu kolaylaştırır, fırça son taramayı yapar. Yapıştırıcıda hassasiyetin varsa önce yama testi yap.",
        "Ono MAC kirpik ürünlerinde %100 orijinal garantisi ve hızlı kargo vardır. Kıvrım seçimi için C/D rehberini, güvenli yapıştırıcı seçimi için kirpik rehberini incele.",
      ],
      bullets: [
        "Doğal: C kıvrım ipek kirpikler",
        "Belirgin: D kıvrım ve mix boylar",
        "Uygulama: cımbız + göz altı pedi",
        "Bakım: kaş-kirpik fırçası ile tarama",
      ],
      links: [
        { label: "C Kıvrım mı D Kıvrım mı?", href: "/blog/ipek-kirpik-secimi-c-kivrim-mi-d-kivrim-mi" },
        { label: "Kirpik Yapıştırıcı Seçimi", href: "/blog/kirpik-yapistirici-secimi-guvenli-urunler" },
        { label: "IB Yapıştırıcı Yeşil", href: "/urunler/ib-kirpik-yapistirici-yesil-lshgl-gr" },
      ],
    },
  },
];

export function getCategoryBySlug(slug: string): CategoryMeta | undefined {
  return categoriesMeta.find((c) => c.slug === slug);
}

export function getAllCategorySlugs(): string[] {
  return categoriesMeta.map((c) => c.slug);
}

const norm = (s: string) =>
  s.toLocaleLowerCase("tr").replace(/-/g, " ").replace(/ı/g, "i").replace(/ş/g, "s").replace(/ğ/g, "g").replace(/ü/g, "u").replace(/ö/g, "o").replace(/ç/g, "c");

/** Kategoriye ait ürünleri bul — keywords ad+kategori+slug içinde aranır. */
export function getProductsForCategory<T extends { name: string; category: string; slug: string }>(
  cat: CategoryMeta,
  all: T[]
): T[] {
  const keys = cat.keywords.map((k) => norm(k));
  return all.filter((p) => {
    const hay = norm(`${p.name} ${p.category} ${p.slug}`);
    return keys.some((k) => hay.includes(k));
  });
}
